var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { AppLogo } from "shared/lib/assets/icons/logo";
var LogoContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  border-radius: 48px;\n"], ["\n  display: flex;\n  border-radius: 48px;\n"])));
var HeaderLogo = function () {
    return (_jsx(_Fragment, { children: _jsx(LogoContainer, { children: _jsx(Link, __assign({ to: "/" }, { children: _jsx(AppLogo, { height: "40px", width: "40px" }, void 0) }), void 0) }, void 0) }, void 0));
};
export default HeaderLogo;
var templateObject_1;
//# sourceMappingURL=HeaderLogo.js.map